import {
  File as Model,
  FileService as Service,
  ResourceStore,
} from '@/internal';

const service = new Service();

const store = new ResourceStore({
  model: Model,
  actions: {
    replace({commit}, payload = {}) {
      return service.replace(payload.id, payload);
    },
  },
});

export default store.toObject();
